module.exports = __webpack_public_path__ + "img/cli-banner-v2.d648176.png";